export default __webpack_public_path__ + "static/media/flix.584a959b.jpg";